import type * as Types from '../../graphql/types.d'

import type { PinnedRouteSelectionFragment } from '../fragments/generated/PinnedRoute'
import type { DocumentNode } from 'graphql'
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>
export type InsertRoutePinMutationVariables = Types.Exact<{
  path: Types.Scalars['String']
}>

export type InsertRoutePinMutation = { __typename?: 'Mutation' } & {
  insertRoutePin: { __typename?: 'PinnedRoute' } & PinnedRouteSelectionFragment
}

export const InsertRoutePinDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'InsertRoutePin' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'insertRoutePin' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'path' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'path' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'PinnedRouteSelection' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'PinnedRouteSelection' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'PinnedRoute' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pinned' } },
          { kind: 'Field', name: { kind: 'Name', value: 'path' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'settings' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationFrequency' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationActive' } },
                { kind: 'Field', name: { kind: 'Name', value: 'notificationChannel' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode
